import * as React from 'react'

import { Box, Icon, Text, useToggle } from '@factorialco/deprecated-design-system'

import useFilters from 'modules/core/components/DataTable/hooks/useFilters'
import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

function AddFilterContent<T>() {
  const { availableFilters } = useFilters<T>()
  const { onValueChange } = Filter.Base.useFilter()

  const options = availableFilters
    .map((filter) => ({
      label: filter.filter.title,
      value: filter.filter.identifier,
    }))
    .sort((option1, option2) => option1.label.localeCompare(option2.label))

  return (
    <Filter.Base.Content
      body={
        <Box flexDirection="column">
          {options.map(({ label, value }) => (
            <Box
              key={value}
              flexDirection="row"
              paddingX="s16"
              paddingY="s12"
              gap="s12"
              component="button"
              justifyContent="spaceBetween"
              onClick={() => onValueChange(value)}
            >
              <Text.Normal size="300" color="grey800" ellipsis>
                {label}
              </Text.Normal>
            </Box>
          ))}
        </Box>
      }
    />
  )
}

export default function AddFilter<T>() {
  const { availableFilters, onAddFilter } = useFilters<T>()
  const [open, setOpen] = useToggle()

  const onCurrentFilterSelect = (value: string) => {
    const filter = availableFilters.find((filter) => filter.filter.identifier === value)
    if (filter) {
      setOpen(false)()
      onAddFilter(filter)
    }
  }

  return (
    <Filter.Base.Provider onValueChange={onCurrentFilterSelect} defaultOpen={false}>
      <Filter.Base.Chip.Toggler
        label={
          <Box gap="s4" flexDirection="row" alignItems="center">
            <Icon.Small icon="add" color="grey700" />
            <Text.Normal size="200" color="grey700">
              {i18n.t('data_table.filters.add_filter')}
            </Text.Normal>
          </Box>
        }
        active={open}
        hideChevron
        noBorder
      />
      <AddFilterContent />
    </Filter.Base.Provider>
  )
}
